export function deepMerge(target: Record<string, unknown>, ...sources: Record<string, unknown>[]) {
	if (!sources.length) return target;
	const source = sources.shift();

	if (isObject(target) && isObject(source)) {
		for (const key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				const sourceValue = source[key];

				if (Array.isArray(sourceValue) && Array.isArray(target[key])) {
					target[key] = sourceValue.concat(target[key]);
				} else if (isObject(sourceValue) && isObject(target[key])) {
					target[key] = deepMerge(target[key] as Record<string, unknown>, sourceValue as Record<string, unknown>);
				} else {
					target[key] = sourceValue;
				}
			}
		}
	}
	return deepMerge(target, ...sources);
}

function isObject(item: unknown) {
	return item !== null && typeof item === 'object' && !Array.isArray(item);
}
